import { Component, OnInit } from '@angular/core';
import { AuthService, Auth } from '../../auth/auth.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(
    private auth: AuthService
  ) { }

  loading: boolean = false;
  error: string = '';

  ngOnInit() {
    this.auth.onAuthChanged
      .subscribe((authState: Auth) => {
        this.loading = false;
        this.error = authState ? authState.message : '';
      });
  }

  private formUser: string;
  private formPasswd: string;

  onLogin() {
    if (!this.formUser || !this.formPasswd) { return; }
    this.error = '';
    this.loading = true;
    this.auth.login(this.formUser, this.formPasswd);
  }
}
